var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',_vm._l((_vm.headers),function(header){return _c('th',{key:header.text},[_vm._v(_vm._s(header.text))])}),0)]),_c('tbody',[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }